import styled from 'styled-components'

export const MainSidebar = styled.div`
  width: ${({ isExpanded }) => (isExpanded ? '180px' : '66px')};
  height: 100%;
  transition: all 0.2s ease-out;
`
